{
  "common": {
    "ok": "确定",
    "cancel": "取消",
    "yes": "是",
    "no": "否",
    "loading": "加载中...",
    "error": "错误",
    "retry": "重试",
    "apply": "应用",
    "add": "添加"
  },
  "navigation": {
    "home": "首页",
    "favorites": "收藏",
    "search": "搜索"
  },
  "jobs": {
    "noJobs": "未找到工作",
    "loadMore": "加载更多",
    "apply": "申请",
    "save": "保存",
    "unsave": "移除"
  },
  "search": {
    "placeholder": "搜索工作...",
    "filter": "筛选",
    "clear": "清除",
    "open": "搜索工作",
    "close": "关闭搜索"
  },
  "alerts": {
    "title": "职位提醒",
    "subtitle": "当有符合你搜索条件的新职位时推送通知。",
    "placeholder": "关键词（如 react 远程 高级）",
    "empty": "还没有提醒",
    "matchingNow": "当前匹配 {{count}} 个"
  },
  "description": {
    "openUrlMessage": "打开URL获取更多信息",
    "postedOn": "发布于",
    "applyViewDetails": "申请 / 查看详情"
  },
  "error": {
    "title": "出错了",
    "description": "抱歉，未找到工作！这可能是服务器或网络错误。",
    "tryAgain": "重试"
  },
  "filter": {
    "refineJobs": "优化工作",
    "title": "筛选",
    "total": "总计",
    "reset": "重置",
    "filterByDate": "按日期筛选",
    "byDate": "按日期",
    "byApplied": "按申请状态",
    "appliedOnlyOn": "仅已申请：开",
    "appliedOnlyOff": "仅已申请：关",
    "postedAfter": "发布于之后",
    "filterByTags": "按标签筛选",
    "byTag": "按标签",
    "clearAllFavorites": "清除所有收藏",
    "applyFilters": "应用筛选"
  },
  "share": {
    "message": "这里有一个很棒的远程工作机会：\n* 职位：{{position}}\n* 公司：{{company}}\n* URL：{{url}}",
    "title": "远程工作应用 - {{position}} @{{company}}",
    "subject": "从远程工作应用分享的工作",
    "dialogTitle": "分享远程工作"
  },
  "datepicker": {
    "selectDate": "选择日期",
    "year": "年",
    "month": "月",
    "previousMonth": "上个月",
    "nextMonth": "下个月",
    "weekdays": [
      "日",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六"
    ],
    "months": [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ]
  },
  "tabs": {
    "allJobs": "所有工作",
    "favorites": "收藏夹",
    "resumeBuilder": "简历",
    "applications": "申请记录",
    "profile": "我的"
  },
  "favorites": {
    "deleteAll": "删除所有收藏",
    "empty": "还没有收藏。点击职位上的爱心即可保存到这里。"
  },
  "icons": {
    "jobActions": "工作操作",
    "addToFavorites": "添加到收藏",
    "removeFromFavorites": "从收藏中移除",
    "share": "分享",
    "openUrl": "打开URL",
    "markApplied": "标记为已申请",
    "removeApplied": "移除已申请"
  },
  "job": {
    "applied": "已申请",
    "fit": "匹配 {{score}}%"
  },
  "list": {
    "found": "条结果"
  },
  "onboarding": {
    "tagline": "发现来自世界各地精心挑选的远程工作机会！",
    "next": "下一步"
  },
  "tour": {
    "skip": "跳过",
    "next": "下一步",
    "getStarted": "开始使用",
    "slides": {
      "welcome": {
        "title": "欢迎",
        "description": "快速浏览主要功能，帮你更快找到下一份远程工作。"
      },
      "search": {
        "title": "搜索和筛选职位",
        "description": "按关键字搜索，并按日期、标签或申请状态筛选结果。"
      },
      "favorites": {
        "title": "收藏与已申请",
        "description": "点击心形保存职位，并标记你已经申请过的职位。"
      },
      "tracker": {
        "title": "跟踪你的求职申请",
        "description": "将职位标记为已申请，并按阶段跟踪每个申请——面试、录用——附带备注和日期。"
      },
      "alerts": {
        "title": "接收新匹配职位提醒",
        "description": "保存搜索条件，当有符合你关键词的新远程职位时即可收到推送通知。"
      },
      "resume": {
        "title": "制作你的简历",
        "description": "创建专业简历，导出为 PDF 或 DOCX，并查看每个职位与你技能的匹配程度。"
      },
      "account": {
        "title": "登录以同步",
        "description": "创建免费账户，将你的简历、申请、收藏和提醒备份到所有设备。"
      },
      "settings": {
        "title": "主题与语言",
        "description": "在浅色和深色模式之间切换，并在设置中从 9 种语言中选择。"
      }
    }
  },
  "theme": {
    "toggle": "切换主题"
  },
  "settings": {
    "title": "设置",
    "theme": "主题",
    "themeLight": "浅色",
    "themeDark": "深色",
    "language": "语言",
    "open": "打开设置",
    "close": "关闭",
    "developer": "开发者",
    "hideAds": "隐藏广告",
    "removeAds": {
      "title": "移除广告",
      "buy": "移除广告 — {{price}}",
      "restore": "恢复购买",
      "purchased": "感谢您支持 RemoteWork！广告已关闭。",
      "successTitle": "广告已移除",
      "successMessage": "感谢您的支持！整个应用中的广告现已关闭。",
      "errorTitle": "购买失败",
      "errorMessage": "出现问题，请重试。",
      "restoreEmptyTitle": "没有可恢复的内容",
      "restoreEmptyMessage": "在此账号下未找到任何之前的购买记录。"
    },
    "tour": "导览",
    "replayTour": "重新查看导览",
    "account": "账户",
    "deleteAccount": {
      "action": "删除账户",
      "confirmTitle": "删除账户？",
      "confirmMessage": "这将永久删除你的账户和所有同步数据——简历、申请、收藏和提醒。此操作无法撤销。",
      "errorTitle": "无法删除账户",
      "errorMessage": "出错了，请重试。",
      "reauthMessage": "为了你的账户安全，请退出登录后重新登录，然后再尝试删除账户。"
    },
    "about": "关于",
    "privacyPolicy": "隐私政策",
    "website": "访问网站"
  },
  "ad": {
    "sponsored": "赞助"
  },
  "consent": {
    "message": "我们使用分析 Cookie 来了解访问者如何使用本网站。在您同意之前保持关闭状态。",
    "accept": "同意",
    "reject": "拒绝"
  },
  "disclaimer": {
    "title": "关于职位信息",
    "message": "本应用中显示的职位来自第三方来源和公共 API。我们不发布、不筛选也不控制这些信息，无法保证任何职位的准确性、质量或有效性。在申请之前，请务必直接向雇主确认相关详情。",
    "okCountdown": "确定 ({{seconds}})"
  },
  "resume": {
    "title": "简历生成器",
    "newResume": "新建",
    "newResumePrompt": "为您的简历命名",
    "namePlaceholder": "例如：前端简历",
    "lastModified": "最近修改",
    "discardTitle": "放弃更改？",
    "discardMessage": "您有未保存的更改。",
    "webPlaceholder": {
      "title": "简历生成器仅在移动端可用",
      "subtitle": "请在 Android 或 iOS 上打开应用以创建并导出您的简历。"
    },
    "actions": {
      "edit": "编辑",
      "duplicate": "复制",
      "delete": "删除",
      "more": "更多选项",
      "deleteConfirmTitle": "删除简历？",
      "deleteConfirmMessage": "永久删除\"{{name}}\"？此操作无法撤销。"
    },
    "empty": {
      "title": "还没有简历",
      "subtitle": "创建一份专业简历，并导出为 PDF 或 DOCX。",
      "cta": "创建第一份简历",
      "skillsHint": "添加诸如 JavaScript、设计、领导力等技能…"
    },
    "sections": {
      "personalInfo": "个人信息",
      "experience": "工作经历",
      "education": "教育背景",
      "skills": "技能",
      "languages": "语言",
      "links": "链接",
      "template": "模板",
      "contact": "联系方式",
      "summary": "简介",
      "personalization": "个性化",
      "preview": "预览"
    },
    "fields": {
      "fullName": "姓名",
      "title": "职业头衔",
      "email": "邮箱",
      "phone": "电话",
      "location": "所在地",
      "website": "网站",
      "summary": "职业简介",
      "company": "公司",
      "position": "职位",
      "institution": "学校",
      "degree": "学位",
      "field": "专业",
      "startDate": "开始日期",
      "endDate": "结束日期",
      "current": "目前在此工作",
      "present": "至今",
      "description": "描述",
      "skillPlaceholder": "添加技能",
      "languageName": "语言",
      "languageProficiency": "熟练程度",
      "linkLabel": "标签",
      "linkUrl": "网址",
      "phoneCountryCode": "国家代码"
    },
    "proficiency": {
      "basic": "基础",
      "conversational": "日常会话",
      "fluent": "流利",
      "native": "母语"
    },
    "templates": {
      "modern": "现代",
      "classic": "经典",
      "minimal": "极简",
      "modernDescription": "带彩色侧边栏的双栏布局。",
      "classicDescription": "传统黑白单栏布局。",
      "minimalDescription": "简洁、留白丰富、无配色。"
    },
    "buttons": {
      "addExperience": "添加经历",
      "addEducation": "添加教育",
      "addLanguage": "添加语言",
      "addLink": "添加链接",
      "remove": "移除",
      "save": "保存",
      "discard": "放弃",
      "export": "导出",
      "exportPdf": "导出为 PDF",
      "exportDocx": "导出为 DOCX",
      "create": "创建",
      "previous": "上一步",
      "next": "下一步"
    },
    "export": {
      "preparing": "正在准备文件…",
      "preparingHint": "选择一种格式。文件准备好后会在分享菜单中打开。",
      "errorTitle": "导出失败",
      "errorMessage": "导出简历时出现问题。"
    },
    "validation": {
      "invalidEmail": "请输入有效的电子邮箱地址。",
      "invalidCountryCode": "最多 4 位数字，可选地以 + 开头。",
      "invalidWebsite": "请输入有效的网站地址（例如 example.com）。"
    },
    "personalization": {
      "title": "个性化",
      "colorMode": "颜色主题",
      "modes": {
        "light": "浅色",
        "dark": "深色"
      },
      "fontFamily": "字体",
      "fonts": {
        "sans": "无衬线",
        "serif": "衬线",
        "modern": "现代",
        "mono": "等宽"
      },
      "fontSize": "字号",
      "sizes": {
        "title": "标题",
        "subtitle": "副标题",
        "body": "正文"
      },
      "increase": "增大{{field}}",
      "decrease": "减小{{field}}"
    },
    "photo": {
      "placeholder": "无照片",
      "choose": "添加照片",
      "change": "更换照片",
      "remove": "移除",
      "permissionTitle": "需要权限",
      "permissionMessage": "请允许访问相册以选择头像。"
    }
  },
  "sort": {
    "recent": "最新",
    "bestFit": "最匹配",
    "toggle": "按匹配度排序"
  },
  "applyKit": {
    "title": "申请工具包",
    "hint": "点按复制后粘贴到申请表单。",
    "copied": "已复制",
    "openExternal": "在浏览器中打开"
  },
  "applications": {
    "title": "申请记录",
    "empty": {
      "title": "还没有申请记录",
      "subtitle": "你申请的职位会显示在这里，方便跟踪状态。"
    },
    "status": {
      "applied": "已申请",
      "interviewing": "面试中",
      "offer": "录用",
      "rejected": "已拒绝"
    },
    "notesPlaceholder": "添加备注…",
    "remove": "移除",
    "removeConfirm": "移除这条申请记录？",
    "lastUpdate": "最后更新：{{date}}",
    "editDate": "编辑日期",
    "addManual": "添加申请"
  },
  "auth": {
    "account": "账户",
    "signIn": "登录",
    "signUp": "创建账户",
    "signOut": "退出登录",
    "title": {
      "signIn": "欢迎回来",
      "signUp": "创建你的账户"
    },
    "email": "邮箱",
    "password": "密码",
    "showPassword": "显示密码",
    "hidePassword": "隐藏密码",
    "forgotPassword": "忘记密码？",
    "resetSent": "密码重置邮件已发送——请查收。",
    "enterEmailFirst": "请先输入邮箱。",
    "noAccount": "还没有账户？创建一个",
    "haveAccount": "已有账户？登录",
    "criteria": {
      "minLength": "至少 8 个字符",
      "uppercase": "一个大写字母",
      "lowercase": "一个小写字母",
      "numeric": "一个数字",
      "special": "一个特殊字符"
    },
    "errors": {
      "invalid-email": "该邮箱地址似乎无效。",
      "invalid-credential": "邮箱或密码不正确。",
      "user-not-found": "未找到使用该邮箱的账户。",
      "wrong-password": "邮箱或密码不正确。",
      "email-already-in-use": "该邮箱已被注册。",
      "weak-password": "该密码不符合要求。",
      "requires-recent-login": "请重新登录以继续。",
      "too-many-requests": "尝试次数过多，请稍后再试。",
      "network": "网络错误，请检查连接。",
      "not-configured": "暂时无法登录。",
      "unknown": "出错了，请重试。"
    },
    "continueGoogle": "使用 Google 继续",
    "continueApple": "使用 Apple 继续",
    "or": "或",
    "loggedInAnonymous": "已匿名登录",
    "continueAnonymous": "匿名继续",
    "loggedOutWarning": "你尚未登录——数据仅保存在本设备上，可能会丢失。"
  },
  "profile": {
    "title": "我的",
    "signInRegister": "登录 / 注册",
    "more": "更多"
  },
  "applyBrowser": {
    "title": "申请"
  }
}
